import { useCallback } from 'react';

import { useUnsavedChanges } from '../../contexts/UnsavedChangesContext';

/** Returns a stable callback that prompts when there are unsaved changes. */
export function useRequestLeave(): () => Promise<boolean> {
  const { requestLeave } = useUnsavedChanges();

  return useCallback(() => requestLeave(), [requestLeave]);
}
